import { LazyQueryExecFunction } from '@apollo/client'
import {
  useBuscaCidadaoListagemDesenvolvimentoInfantilLazyQuery,
  useBuscaCidadaoListagemDiabetesLazyQuery,
  useBuscaCidadaoListagemGeralLazyQuery,
  useBuscaCidadaoListagemGestantePuerperaLazyQuery,
  useBuscaCidadaoListagemHipertensaoLazyQuery,
  useBuscaCidadaoListagemPessoaIdosaLazyQuery,
  useBuscaCidadaoListagemSaudeBucalLazyQuery,
  useBuscaCidadaoListagemTematicaSaudeMulherLazyQuery,
} from 'graphql/hooks.generated'
import { LazyQueryResultArray } from 'graphql/hooks/useLazyQuery'
import { AcompanhamentoCondicaoSaudeTematicaEnum } from 'graphql/types.generated'

import {
  BuscaCidadaoQuery,
  BuscaCidadaoQueryResult,
  BuscaCidadaoQueryVariables,
} from '../model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'

type BuscaCidadaoListagemLazyQueryExecFunction = LazyQueryExecFunction<BuscaCidadaoQuery, BuscaCidadaoQueryVariables>
type BuscaCidadaoListagemLazyQueryByTematicaRecord = Partial<
  Record<AcompanhamentoCondicaoSaudeTematicaEnum, LazyQueryResultArray<BuscaCidadaoQuery, BuscaCidadaoQueryVariables>>
>

interface UseBuscaCidadaoListagemResult {
  executeQuery: BuscaCidadaoListagemLazyQueryExecFunction
  abortQuery: () => void
  cidadaos: BuscaCidadaoQueryResult
  loading: boolean
  aborted: boolean
  cidsConsiderados: ReadonlyArray<string>
  ciapsConsiderados: ReadonlyArray<string>
}

export function useBuscaCidadaoListagem(
  tematica: AcompanhamentoCondicaoSaudeTematicaEnum
): UseBuscaCidadaoListagemResult {
  const buscaCidadaoListagemLazyQueryByTematica: BuscaCidadaoListagemLazyQueryByTematicaRecord = {
    [AcompanhamentoCondicaoSaudeTematicaEnum.GERAL]: useBuscaCidadaoListagemGeralLazyQuery(),
    [AcompanhamentoCondicaoSaudeTematicaEnum.GESTANTE_PUERPERA]: useBuscaCidadaoListagemGestantePuerperaLazyQuery(),
    [AcompanhamentoCondicaoSaudeTematicaEnum.DESENVOLVIMENTO_INFANTIL]: useBuscaCidadaoListagemDesenvolvimentoInfantilLazyQuery(),
    [AcompanhamentoCondicaoSaudeTematicaEnum.DIABETES]: useBuscaCidadaoListagemDiabetesLazyQuery(),
    [AcompanhamentoCondicaoSaudeTematicaEnum.HIPERTENSAO_ARTERIAL]: useBuscaCidadaoListagemHipertensaoLazyQuery(),
    [AcompanhamentoCondicaoSaudeTematicaEnum.PESSOA_IDOSA]: useBuscaCidadaoListagemPessoaIdosaLazyQuery(),
    [AcompanhamentoCondicaoSaudeTematicaEnum.SAUDE_MULHER]: useBuscaCidadaoListagemTematicaSaudeMulherLazyQuery(),
    [AcompanhamentoCondicaoSaudeTematicaEnum.SAUDE_BUCAL]: useBuscaCidadaoListagemSaudeBucalLazyQuery(),
  }

  const [execute, result] = buscaCidadaoListagemLazyQueryByTematica[tematica] ?? []

  return {
    executeQuery: execute ?? noop,
    abortQuery: result?.abort ?? noop,
    cidadaos: result?.data?.acompanhamentoCondicaoSaude,
    loading: result?.loading ?? false,
    aborted: result?.aborted ?? false,
    cidsConsiderados: result?.data?.acompanhamentoCondicaoSaude.cidsConsiderados ?? [],
    ciapsConsiderados: result?.data?.acompanhamentoCondicaoSaude.ciapsConsiderados ?? [],
  }
}

const noop = () => undefined
